/*
 * SCSS → Tailwind token mapping (CreateNewIntakeFormQuestionsBuilder.scss deleted):
 *
 * .qb-container:
 *   background:--surface-secondary / border:1.5px solid --highlight / border-radius:12px / overflow:hidden
 *   → bg-deep-navy-5 border-[1.5px] border-border-highlight rounded-xl overflow-hidden
 *   &.qb-error: border-color:--text-error → border-text-error
 *
 * .qb-selector-header:
 *   display:flex / align-items:center / gap:10px / padding:16px 20px
 *   → flex items-center gap-[10px] py-sp-2 px-[20px]
 *
 * .qb-selector-header-icon / .qb-edit-header-icon:
 *   flex / center / w:36px h:36px / rounded-full / bg:rgba(37,56,69,0.1) / shrink-0 / color:--text-dark
 *   → flex items-center justify-center w-[36px] h-[36px] rounded-full bg-text-dark/10 shrink-0 text-text-dark
 *
 * .qb-selector-header-label:
 *   font-size:16px / font-weight:600 / color:--highlight → text-size-4 font-semibold text-text-highlight
 *
 * .qb-type-grid:
 *   grid / grid-cols:2 / gap:10px / padding:0 20px 20px
 *   → grid grid-cols-2 gap-[10px] px-[20px] pb-[20px]
 *
 * .qb-type-card:
 *   flex / items-start / gap:12px / padding:14px 16px / bg:white / border / rounded:8px
 *   cursor / text-left / transition / hover:border-highlight / hover:shadow
 *   → flex items-start gap-[12px] py-[14px] px-sp-2 bg-white border border-shade-10
 *     rounded-large cursor-pointer text-left transition-colors
 *     hover:border-border-highlight hover:shadow-[0_0_0_2px_rgba(0,162,178,0.12)]
 *
 * .qb-type-card-icon:
 *   flex / center / w:36px h:36px / rounded-full / bg:--surface-secondary / shrink-0
 *   → flex items-center justify-center w-[36px] h-[36px] rounded-full bg-deep-navy-5 shrink-0 text-text-dark
 *
 * .qb-type-card-text: flex / flex-col / gap:2px → flex flex-col gap-0.5
 *
 * .qb-type-card-desc / .qb-edit-header-desc:
 *   font-size:12px / color:--text-medium / margin:0 / line-height:16px
 *   → text-size-2 text-text-light m-0 leading-4
 *
 * .qb-selector-footer:
 *   flex / justify-between / padding:14px 20px / border-top / bg:--surface-secondary
 *   → flex items-center justify-between py-[14px] px-[20px] border-t border-shade-10 bg-deep-navy-5
 *
 * .qb-selector-hint: font-size:13px / color:--text-medium → text-[13px] text-text-light
 *
 * .qb-footer-actions: flex / items-center / gap:10px → flex items-center gap-[10px]
 *
 * .qb-edit-header:
 *   flex / justify-between / gap:12px / padding:16px 20px
 *   → flex items-center justify-between gap-[12px] py-sp-2 px-[20px]
 *
 * .qb-edit-header-left: flex / items-center / gap:12px → flex items-center gap-[12px]
 *
 * .qb-edit-header-info: flex / flex-col / gap:2px → flex flex-col gap-0.5
 *
 * .qb-change-btn:
 *   flex / items-center / gap:6px / bg:none / border:none / padding:6px 8px / cursor
 *   font-size:14px / font-weight:600 / color:--highlight / rounded:6px / whitespace:nowrap / shrink-0
 *   hover: bg:rgba(0,162,178,0.08)
 *   → flex items-center gap-1.5 bg-transparent border-none py-1.5 px-2 cursor-pointer
 *     text-size-3 font-semibold text-text-highlight rounded-md whitespace-nowrap shrink-0
 *     hover:bg-[rgba(0,162,178,0.08)]
 *
 * .qb-edit-body:
 *   bg:white / border-t / border-b / padding:20px / flex / flex-col / gap:20px
 *   → bg-white border-t border-b border-shade-10 p-[20px] flex flex-col gap-[20px]
 *
 * .qb-field: flex / flex-col / gap:6px → flex flex-col gap-1.5
 *
 * .qb-field-error: font-size:12px / color:--text-error → text-size-2 text-text-error
 *
 * .qb-edit-footer:
 *   flex / justify-between / padding:14px 20px → flex items-center justify-between py-[14px] px-[20px]
 *
 * .qb-required-row: flex / items-center / gap:10px → flex items-center gap-[10px]
 *
 * .qb-type-text-icon: font-size:16px / font-weight:700 / color:--text-dark
 *   → text-size-4 font-bold text-text-dark
 *
 * Arbitrary values: gap-[10px], gap-[12px], gap-[20px], py-[14px], px-[20px], pb-[20px],
 *   w-[36px], h-[36px], border-[1.5px], p-[20px], text-[13px],
 *   text-text-highlight (DS token for --highlight / #178199)
 */
import { memo, useCallback, useState } from 'react'
import type { ChangeEvent, ReactNode } from 'react'
import {
  Button,
  Input,
  Switch,
  Label,
  EditIcon,
  ClipboardListIcon,
  EnvelopeIcon,
  BullhornIcon,
  ArrowsRepeatIcon,
  StethoscopeIcon,
  PrescriptionBottlePillIcon,
} from '@quickmd-llc/design-system'
import { BuilderOptionsBlockSingleSelectFollowUp } from '../BuilderOptionsBlockSingleSelectFollowUp/BuilderOptionsBlockSingleSelectFollowUp'
import { BuilderOptionsBlockHeightWeight } from '../BuilderOptionsBlockHeightWeight/BuilderOptionsBlockHeightWeight'
import { BuilderOptionsBlock } from '../BuilderOptionsBlock/BuilderOptionsBlock'
import {
  INTAKE_FORM_TYPE_EMAIL_TEXT,
  INTAKE_FORM_TYPE_FILE_UPLOAD_BOX_TEXT,
  INTAKE_FORM_TYPE_MULTIPLE_CHOICE_TEXT,
  INTAKE_FORM_TYPE_SINGLE_TEXT,
  INTAKE_FORM_TYPE_STATEMENT_TEXT,
  INTAKE_FORM_TYPE_TEXT_BOX_TEXT,
  INTAKE_FORMS_CANCEL_BTN_TEXT,
  INTAKE_FORM_TYPE_HEIGHT_WEIGHT_TEXT,
  INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT,
  INTAKE_FORM_PREFERRED_PHARMACY_QUESTION,
} from '../../../../../utils/constants'
import { IntakeQuestionItem } from '../IntakeQuestionItem/IntakeQuestionItem'
import { IS_REQUIRED_CHECKBOX_TYPE } from '../../Constants'

type QuestionTypeConfig = {
  value: string
  label: string
  desc: string
  icon: ReactNode
}

const QUESTION_TYPES_CONFIG: QuestionTypeConfig[] = [
  {
    value: INTAKE_FORM_TYPE_MULTIPLE_CHOICE_TEXT,
    label: 'Multiple choice',
    desc: 'Pick one or more from a list of options',
    icon: <ClipboardListIcon iconSize='m' />,
  },
  {
    value: INTAKE_FORM_TYPE_EMAIL_TEXT,
    label: 'Email',
    desc: 'Validated email address input',
    icon: <EnvelopeIcon iconSize='m' />,
  },
  {
    value: INTAKE_FORM_TYPE_STATEMENT_TEXT,
    label: 'Statement',
    desc: 'Informational text shown to the patient',
    icon: <BullhornIcon iconSize='m' />,
  },
  {
    value: INTAKE_FORM_TYPE_TEXT_BOX_TEXT,
    label: 'Text box',
    desc: 'Free-form text response',
    icon: <span className='text-size-4 font-bold text-text-dark'>T</span>,
  },
  {
    value: INTAKE_FORM_TYPE_SINGLE_TEXT,
    label: 'Yes/No with follow-up',
    desc: 'Conditional follow-up based on answer',
    icon: <ArrowsRepeatIcon iconSize='m' />,
  },
  {
    value: INTAKE_FORM_TYPE_HEIGHT_WEIGHT_TEXT,
    label: 'Height & weight',
    desc: 'Body measurement input (US or metric)',
    icon: <StethoscopeIcon iconSize='m' />,
  },
  {
    value: INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT,
    label: 'Select pharmacy',
    desc: 'Pharmacy lookup & selection',
    icon: <PrescriptionBottlePillIcon iconSize='m' />,
  },
]

/**
 * The broadest option shape: all fields from both multiple-choice
 * and single-select-follow-up variants, with optional fields.
 */
type OptionItem = {
  optionId: string
  optionValue: string
  optionLocalError?: string
  isOptionError?: boolean
  hasFollowUp?: boolean
  followUpText?: string
  followUpRequired?: boolean
}

type FileFormatOption = {
  value: string
  allowedFormats: string[]
  isActive: boolean
}

type Props = {
  questionTypeValue: string
  fileFormatOptions: FileFormatOption[]
  questionOptionsList: OptionItem[]
  questionCheckBoxMultipleAnswersValue: boolean
  onChangeQuestionTypeValue: (builderId: string, value: string) => void
  onChangeFileFormatValue: (builderId: string, value: FileFormatOption[]) => void
  onChangeQuestionMessageValue: (builderId: string, value: string) => void
  onChangeCheckboxesValue: (builderId: string, checkBoxType: string, value: boolean) => void
  onChangeQuestionOptionErrorValue: (builderId: string, optionId: string, errorText: string) => void
  onChangeQuestionOptionValue: (builderId: string, optionId: string, value: string) => void
  questionTypeError: boolean
  questionTypeLocalError: string
  fileFormatError: boolean
  fileFormatLocalError: string
  questionMessageValueError: boolean
  questionMessageValueLocalError: string
  isOptionsValuesError: boolean
  onCancelBtnPress: (builderId: string) => void
  previouslySavedQuestionCancelBtnPress: (builderId: string) => void
  onEditSavedQuestion: (builderId: string) => void
  builderId: string
  onSaveBtnPress: (
    questionTypeValue: string,
    questionMessage: string,
    builderId: string,
    questionOptionsList: OptionItem[],
    isRequired: boolean,
  ) => void
  isSaved: boolean
  isPreviouslySaved: boolean
  onNewQuestionBtnToolPress: (questionListLength: number) => void
  questionNumber: number
  questionMessage: string
  isPublished?: boolean
  isLastInList?: boolean
  onAddOptionIconPress: (initiatorIndex: number, builderId: string) => void
  isRequiredValue: boolean
  onDeleteQuestion: (builderId: string) => void
  onDuplicateQuestion?: ((builderId: string) => void) | undefined
  previouslyIsRequiredValue?: boolean
  onToggleFollowUp: (builderId: string, optionId: string) => void
  onChangeFollowUpText: (builderId: string, optionId: string, value: string) => void
  onChangeFollowUpRequired: (builderId: string, optionId: string, value: boolean) => void
  onPageCancel?: (() => void) | undefined
}

/**
 * Type predicate: checks that an option item has the required fields
 * for BuilderOptionsBlock (non-optional optionLocalError + isOptionError).
 */
function isBasicOption(opt: OptionItem): opt is OptionItem & { optionLocalError: string; isOptionError: boolean } {
  return typeof opt.optionLocalError === 'string' && typeof opt.isOptionError === 'boolean'
}

/**
 * Type predicate: checks that an option has the fields required
 * for BuilderOptionsBlockSingleSelectFollowUp (hasFollowUp + followUpText + followUpRequired).
 */
function isConditionOption(opt: OptionItem): opt is OptionItem & {
  optionLocalError: string
  isOptionError: boolean
  hasFollowUp: boolean
  followUpText: string
  followUpRequired: boolean
} {
  return (
    typeof opt.hasFollowUp === 'boolean' &&
    typeof opt.followUpText === 'string' &&
    typeof opt.followUpRequired === 'boolean'
  )
}

const CreateNewIntakeFormQuestionsBuilder = memo(
  ({
    questionTypeValue,
    fileFormatOptions: _fileFormatOptions,
    questionOptionsList,
    questionCheckBoxMultipleAnswersValue,
    onChangeQuestionTypeValue,
    onChangeFileFormatValue: _onChangeFileFormatValue,
    onChangeQuestionMessageValue,
    onChangeCheckboxesValue,
    onChangeQuestionOptionErrorValue,
    onChangeQuestionOptionValue,
    questionTypeError,
    questionTypeLocalError: _questionTypeLocalError,
    fileFormatError: _fileFormatError,
    fileFormatLocalError: _fileFormatLocalError,
    questionMessageValueError,
    questionMessageValueLocalError,
    isOptionsValuesError,
    onCancelBtnPress,
    previouslySavedQuestionCancelBtnPress,
    onEditSavedQuestion,
    builderId,
    onSaveBtnPress,
    isSaved,
    isPreviouslySaved,
    onNewQuestionBtnToolPress: _onNewQuestionBtnToolPress,
    questionNumber,
    questionMessage,
    isPublished,
    isLastInList: _isLastInList,
    onAddOptionIconPress,
    isRequiredValue,
    onDeleteQuestion,
    onDuplicateQuestion,
    previouslyIsRequiredValue,
    onToggleFollowUp,
    onChangeFollowUpText,
    onChangeFollowUpRequired,
    onPageCancel,
  }: Props) => {
    const [isRequired, setIsRequired] = useState<boolean>(isRequiredValue)
    // showTypeSelector starts false when a type is already selected; the onChangeQuestionType
    // handler also sets it false after selection. No effect needed — derived from initial prop.
    const [showTypeSelector, setShowTypeSelector] = useState<boolean>(!questionTypeValue)

    const onChangeIsRequired = useCallback(
      (value: boolean) => {
        onChangeCheckboxesValue(builderId, IS_REQUIRED_CHECKBOX_TYPE, value)
        setIsRequired(value)
      },
      [builderId, onChangeCheckboxesValue],
    )

    const onChangeQuestionType = useCallback(
      (value: string) => {
        if (value !== questionTypeValue) {
          setIsRequired(false)
          onChangeCheckboxesValue(builderId, IS_REQUIRED_CHECKBOX_TYPE, false)
        }
        onChangeQuestionTypeValue(builderId, value)
        setShowTypeSelector(false)
      },
      [builderId, onChangeQuestionTypeValue, questionTypeValue, onChangeCheckboxesValue],
    )

    const onChangeQuestionMessage = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        onChangeQuestionMessageValue(builderId, e.target.value)
      },
      [builderId, onChangeQuestionMessageValue],
    )

    const onCancelPress = useCallback(() => {
      onCancelBtnPress(builderId)
    }, [builderId, onCancelBtnPress])

    const onPreviouslySavedCancelPress = useCallback(() => {
      setIsRequired(previouslyIsRequiredValue ?? false)
      previouslySavedQuestionCancelBtnPress(builderId)
    }, [builderId, previouslySavedQuestionCancelBtnPress, previouslyIsRequiredValue])

    const onSavePress = useCallback(() => {
      onSaveBtnPress(questionTypeValue, questionMessage, builderId, questionOptionsList, isRequired)
    }, [builderId, onSaveBtnPress, questionMessage, questionOptionsList, questionTypeValue, isRequired])

    const onEditSavedQuestionClick = useCallback(() => {
      onEditSavedQuestion(builderId)
    }, [builderId, onEditSavedQuestion])

    const onDeleteQuestionClick = useCallback(() => {
      onDeleteQuestion(builderId)
    }, [builderId, onDeleteQuestion])

    const onDuplicateQuestionClick = useCallback(() => {
      if (onDuplicateQuestion) {
        onDuplicateQuestion(builderId)
      }
    }, [builderId, onDuplicateQuestion])

    const cancelBtnCorrectHandler = isPreviouslySaved ? onPreviouslySavedCancelPress : onCancelPress

    if (isSaved || isPublished) {
      return (
        <IntakeQuestionItem
          key={builderId}
          questionNumber={questionNumber}
          onEditSavedQuestion={onEditSavedQuestionClick}
          onDeleteQuestion={onDeleteQuestionClick}
          onDuplicateQuestion={onDuplicateQuestion ? onDuplicateQuestionClick : undefined}
          type={questionTypeValue}
          questionMess={questionMessage}
          isRequired={isRequiredValue}
        />
      )
    }

    const isBuilderErrorBorder = questionTypeError || questionMessageValueError || isOptionsValuesError
    const currentTypeConfig = QUESTION_TYPES_CONFIG.find((t) => t.value === questionTypeValue)

    const showQuestionField =
      questionTypeValue !== INTAKE_FORM_TYPE_HEIGHT_WEIGHT_TEXT && questionTypeValue !== '' && questionTypeValue != null

    const containerClass = `bg-deep-navy-5 border-[1.5px] ${isBuilderErrorBorder ? 'border-text-error' : 'border-border-highlight'} rounded-xl overflow-hidden`

    /* Narrow option lists for each sub-block */
    const basicOptions = questionOptionsList.filter(isBasicOption)
    const conditionOptions = questionOptionsList.filter(isConditionOption)

    /* Type selector */
    if (showTypeSelector) {
      const selectorCancelHandler = !isPreviouslySaved && onPageCancel ? onPageCancel : cancelBtnCorrectHandler

      return (
        <div className={containerClass}>
          <div className='flex items-center gap-[10px] px-[20px] py-sp-2'>
            <div className='flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-full bg-text-dark/10 text-text-dark'>
              <ClipboardListIcon iconSize='m' />
            </div>
            <span className='text-size-4 font-semibold text-text-highlight'>Choose a question type</span>
          </div>

          <div className='grid grid-cols-2 gap-[10px] px-[20px] pb-[20px]' data-testid='pw_if-question-type-grid'>
            {QUESTION_TYPES_CONFIG.map((typeConfig) => (
              <button
                key={typeConfig.value}
                className='flex cursor-pointer items-start gap-[12px] rounded-large border border-shade-10 bg-white px-sp-2 py-[14px] text-left transition-colors hover:border-border-highlight hover:shadow-[0_0_0_2px_rgba(0,162,178,0.12)]'
                type='button'
                data-testid={`pw_if-question-type-card-${typeConfig.value}`}
                onClick={() => onChangeQuestionType(typeConfig.value)}>
                <div className='flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-full bg-deep-navy-5 text-text-dark'>
                  {typeConfig.icon}
                </div>
                <div className='flex flex-col gap-0.5'>
                  <Label size='md'>{typeConfig.label}</Label>
                  <p className='m-0 text-size-2 leading-4 text-text-light'>{typeConfig.desc}</p>
                </div>
              </button>
            ))}
          </div>

          <div className='flex items-center justify-between border-t border-shade-10 bg-deep-navy-5 px-[20px] py-[14px]'>
            <span className='text-[13px] text-text-light'>ⓘ Pick a question type to continue</span>
            <div className='flex items-center gap-[10px]'>
              <Button priority='secondary' size='s' onClick={selectorCancelHandler}>
                Cancel
              </Button>
              <Button priority='primary' size='s' disabled>
                Save question
              </Button>
            </div>
          </div>
        </div>
      )
    }

    /* Edit form */
    return (
      <div className={containerClass}>
        {/* Header */}
        <div className='flex items-center justify-between gap-[12px] px-[20px] py-sp-2'>
          <div className='flex items-center gap-[12px]'>
            <div className='flex h-[36px] w-[36px] shrink-0 items-center justify-center rounded-full bg-text-dark/10 text-text-dark'>
              {currentTypeConfig?.icon}
            </div>
            <div className='flex flex-col gap-0.5'>
              <Label size='md'>{currentTypeConfig?.label ?? questionTypeValue}</Label>
              {currentTypeConfig?.desc ?
                <p className='m-0 text-size-2 leading-4 text-text-light'>{currentTypeConfig.desc}</p>
              : null}
            </div>
          </div>
          <button
            className='flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border-none bg-transparent px-2 py-1.5 text-size-3 font-semibold text-text-highlight hover:bg-[rgba(0,162,178,0.08)]'
            type='button'
            onClick={() => setShowTypeSelector(true)}>
            <EditIcon iconSize='s' />
            Change question
          </button>
        </div>

        {/* Body */}
        <div className='flex flex-col gap-[20px] border-b border-t border-shade-10 bg-white p-[20px]'>
          {showQuestionField ?
            <div className='flex flex-col gap-1.5'>
              <Label size='md'>Question</Label>
              <Input
                value={
                  questionTypeValue === INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT ?
                    `${INTAKE_FORM_PREFERRED_PHARMACY_QUESTION}?`
                  : questionMessage
                }
                onChange={onChangeQuestionMessage}
                disabled={questionTypeValue === INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT}
                error={questionMessageValueError}
                placeholder='Enter your question'
              />
              {questionMessageValueError && questionMessageValueLocalError ?
                <span className='text-size-2 text-text-error'>{questionMessageValueLocalError}</span>
              : null}
            </div>
          : null}

          {questionTypeValue === INTAKE_FORM_TYPE_SINGLE_TEXT ?
            <BuilderOptionsBlockSingleSelectFollowUp
              options={conditionOptions}
              builderId={builderId}
              isRequired={isRequired}
              onChangeQuestionOptionValue={onChangeQuestionOptionValue}
              onChangeQuestionOptionErrorValue={onChangeQuestionOptionErrorValue}
              onToggleFollowUp={onToggleFollowUp}
              onChangeFollowUpText={onChangeFollowUpText}
              onChangeFollowUpRequired={onChangeFollowUpRequired}
            />
          : questionTypeValue === INTAKE_FORM_TYPE_HEIGHT_WEIGHT_TEXT ?
            <BuilderOptionsBlockHeightWeight options={questionOptionsList} />
          : <BuilderOptionsBlock
              options={basicOptions}
              builderId={builderId}
              questionTypeValue={questionTypeValue}
              onAddOptionIconPress={onAddOptionIconPress}
              onChangeQuestionOptionErrorValue={onChangeQuestionOptionErrorValue}
              onChangeQuestionOptionValue={onChangeQuestionOptionValue}
            />
          }
        </div>

        {/* Footer */}
        <div className='flex items-center justify-between px-[20px] py-[14px]'>
          <div className='flex items-center gap-[10px]'>
            {questionTypeValue !== INTAKE_FORM_TYPE_FILE_UPLOAD_BOX_TEXT && (
              <>
                <Switch size='m' checked={isRequired} onChange={onChangeIsRequired} />
                <Label size='md'>Required</Label>
              </>
            )}
            {questionTypeValue === INTAKE_FORM_TYPE_MULTIPLE_CHOICE_TEXT && (
              <>
                <Switch
                  size='m'
                  checked={questionCheckBoxMultipleAnswersValue}
                  onChange={(val) => onChangeCheckboxesValue(builderId, 'EnableMultipleAnswers', val)}
                />
                <Label size='md'>Enable multiple answers</Label>
              </>
            )}
          </div>
          <div className='flex items-center gap-[10px]'>
            <Button priority='secondary' size='s' onClick={cancelBtnCorrectHandler}>
              {INTAKE_FORMS_CANCEL_BTN_TEXT}
            </Button>
            <Button priority='primary' size='s' onClick={onSavePress}>
              Save question
            </Button>
          </div>
        </div>
      </div>
    )
  },
)

export { CreateNewIntakeFormQuestionsBuilder }
